"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFound = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useTranslation2 = require("../../../hooks/useTranslation");
var _utils = require("../../../utils");
var _Container = require("../../layout/footer/Container");
var _Button = require("../../ui/buttons/Button");
var _fonts = require("../../ui/fonts");
var _Container2 = require("../../ui/Container");
var _Svg = require("../../ui/Svg");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var backgroundImage = function backgroundImage(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0",
    maskType: "alpha",
    maskUnits: "userSpaceOnUse",
    x: "3",
    y: "6",
    width: "994",
    height: "413"
  }, /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.4",
    d: "M179.121 412V335.429H3.69346V262.286L159.122 13.1442H260.835V269.143H311.121V335.429H260.835V412H179.121ZM72.2647 269.143H179.121V101.715H173.407L72.2647 269.143ZM500.611 418.857C448.421 418.857 409.755 400.762 384.612 364.572C359.469 328.381 346.898 277.715 346.898 212.572C346.898 147.429 359.469 96.7629 384.612 60.5726C409.755 24.3822 448.421 6.28702 500.611 6.28702C552.802 6.28702 591.468 24.3822 616.611 60.5726C641.754 96.7629 654.325 147.429 654.325 212.572C654.325 277.715 641.754 328.381 616.611 364.572C591.468 400.762 552.802 418.857 500.611 418.857ZM500.611 346.286C523.469 346.286 539.278 337.905 548.04 321.143C556.802 304.381 561.183 280.762 561.183 250.286V174.858C561.183 144.382 556.802 120.763 548.04 104.001C539.278 87.2392 523.469 78.8582 500.611 78.8582C477.754 78.8582 461.945 87.2392 453.183 104.001C444.421 120.763 440.04 144.382 440.04 174.858V250.286C440.04 280.762 444.421 304.381 453.183 321.143C461.945 337.905 477.754 346.286 500.611 346.286ZM864.387 412V335.429H688.959V262.286L844.387 13.1442H946.101V269.143H996.387V335.429H946.101V412H864.387ZM757.53 269.143H864.387V101.715H858.673L757.53 269.143Z",
    fill: "#5258CD"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.4",
    d: "M179.121 412V335.429H3.69346V262.286L159.122 13.1442H260.835V269.143H311.121V335.429H260.835V412H179.121ZM72.2647 269.143H179.121V101.715H173.407L72.2647 269.143ZM500.611 418.857C448.421 418.857 409.755 400.762 384.612 364.572C359.469 328.381 346.898 277.715 346.898 212.572C346.898 147.429 359.469 96.7629 384.612 60.5726C409.755 24.3822 448.421 6.28702 500.611 6.28702C552.802 6.28702 591.468 24.3822 616.611 60.5726C641.754 96.7629 654.325 147.429 654.325 212.572C654.325 277.715 641.754 328.381 616.611 364.572C591.468 400.762 552.802 418.857 500.611 418.857ZM500.611 346.286C523.469 346.286 539.278 337.905 548.04 321.143C556.802 304.381 561.183 280.762 561.183 250.286V174.858C561.183 144.382 556.802 120.763 548.04 104.001C539.278 87.2392 523.469 78.8582 500.611 78.8582C477.754 78.8582 461.945 87.2392 453.183 104.001C444.421 120.763 440.04 144.382 440.04 174.858V250.286C440.04 280.762 444.421 304.381 453.183 321.143C461.945 337.905 477.754 346.286 500.611 346.286ZM864.387 412V335.429H688.959V262.286L844.387 13.1442H946.101V269.143H996.387V335.429H946.101V412H864.387ZM757.53 269.143H864.387V101.715H858.673L757.53 269.143Z",
    fill: "#5258CD"
  }), /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M728.053 360.618C779.858 317.261 786.609 239.889 743.038 187.96C699.466 136.032 622.218 129.066 570.413 172.423C518.608 215.781 511.857 293.153 555.429 345.081C599 397.01 676.32 404.016 728.053 360.618Z",
    fill: "#5DD9BD"
  })), /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M445.205 520.296C517.719 459.606 527.169 351.304 466.18 278.617C405.19 205.93 297.062 196.18 224.548 256.87C152.034 317.559 142.584 425.861 203.574 498.548C264.563 571.235 372.792 581.043 445.205 520.296Z",
    fill: "#FF8401"
  }))), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "758.747",
    cy: "453.202",
    rx: "96.7474",
    ry: "34.6491",
    fill: "#1F1F37"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "881.424",
    cy: "436.036",
    rx: "74.5",
    ry: "20.5195",
    transform: "rotate(-4.27015 881.424 436.036)",
    fill: "#1F1F37"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M630.559 329.357C630.559 329.357 624.115 334.97 622.359 343.454",
    stroke: "#E5A05C",
    strokeWidth: "1.12322",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M629.051 325.929C629.051 325.929 621.023 328.862 616.326 336.155",
    stroke: "#E5A05C",
    strokeWidth: "1.12322",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M660.137 402.961C652.071 352.609 645.788 358.137 672.955 358.138C681.76 358.138 696.228 378.712 693.636 403.183C689.706 429.266 685.97 465.192 670.722 457.091C662.256 452.594 664.469 430.006 660.137 402.961Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M674.251 457.18C674.04 455.574 674.094 452.66 674.251 451.261",
    stroke: "#E5A05C",
    strokeWidth: "2.04752",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M889.169 441.39C864.711 441.503 827.34 432.274 804.558 424.781C799.166 422.71 794.913 421.106 791.668 419.758C788.628 418.048 786.373 416.781 784.808 415.901C784.451 410.566 818.266 362.593 823.265 388.593C836.265 421.593 892.271 412.445 905.155 412.142C932.411 411.501 946.589 413.744 947.329 424.801C948.069 435.858 918.111 441.255 889.169 441.39Z",
    fill: "#F9B466"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.836 265.419C645.184 255.655 645.837 250.448 649.747 251.75C653.657 253.052 667.857 264.798 671.908 269.324C672.279 269.738 672.6 270.126 672.876 270.491C696.177 272.653 727.833 284.362 769.007 314.821C828.537 358.859 822.946 401.992 807.854 427.042C800.313 436.753 792.925 443.702 787.639 447.91C769.007 457.124 713.724 465.519 676.664 410.236C671.34 402.294 667.759 394.27 664.248 386.401C660.018 376.919 655.888 367.663 648.929 359.048C633.772 340.282 618.85 318.396 619.352 300.769C619.119 300.544 618.876 300.293 618.623 300.017C614.991 296.051 605.891 282.514 605.089 278.957C604.287 275.401 608.934 275.286 617.482 276.723C623.093 277.667 627.888 279.277 630.521 280.272C634.593 277.165 639.941 274.339 646.649 272.461C646.301 270.309 646.004 267.928 645.836 265.419Z",
    fill: "#F9B466"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask1",
    maskType: "alpha",
    maskUnits: "userSpaceOnUse",
    x: "605",
    y: "270",
    width: "213",
    height: "185"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M630.52 280.272C648.715 266.39 692.374 258.131 769.007 314.821C823.908 355.434 823.421 395.278 811.176 420.878C803.393 434.091 794.092 442.715 787.639 447.91C769.007 457.123 713.724 465.518 676.664 410.235C671.34 402.293 667.759 394.269 664.248 386.4C660.018 376.919 655.888 367.663 648.929 359.047C633.772 340.282 618.85 318.396 619.352 300.769C619.119 300.544 618.876 300.293 618.623 300.016C614.991 296.051 605.891 282.514 605.089 278.957C604.287 275.4 608.934 275.286 617.482 276.723C623.093 277.666 627.888 279.277 630.52 280.272Z",
    fill: "#F9B466"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "608.086",
    cy: "303.228",
    rx: "30.3033",
    ry: "37.3074",
    transform: "rotate(-8.93406 608.086 303.228)",
    fill: "#E5A05C"
  }), /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "762.553",
    cy: "297.596",
    rx: "49.0012",
    ry: "55.9541",
    transform: "rotate(-41.0196 762.553 297.596)",
    fill: "#E5A05C"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M823.761 419.643C816.163 443.752 793.385 458.059 772.884 451.598C752.384 445.138 741.924 420.356 749.522 396.247C757.119 372.137 771.764 336.632 792.265 343.093C812.766 349.554 831.359 395.533 823.761 419.643Z",
    fill: "#F9B466"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M651.843 328.518C651.843 328.518 661.429 330.756 667.79 338.442",
    stroke: "#E5A05C",
    strokeWidth: "1.12322",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M652.708 323.267C652.708 323.267 662.385 321.465 671.318 325.938",
    stroke: "#E5A05C",
    strokeWidth: "1.12322",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M640.029 330.52C638.59 330.717 632.506 327.144 639.469 326.244C646.453 325.327 641.463 330.359 640.029 330.52Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M646.951 320.766C647.656 320.253 647.812 319.265 647.298 318.559C646.785 317.854 645.797 317.698 645.092 318.212C644.386 318.725 644.231 319.713 644.744 320.418C645.258 321.124 646.246 321.279 646.951 320.766Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M630.455 324.243C631.161 323.729 631.316 322.741 630.803 322.036C630.289 321.331 629.301 321.175 628.596 321.688C627.891 322.202 627.735 323.19 628.248 323.895C628.762 324.6 629.75 324.756 630.455 324.243Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M722.044 405.595C727.348 369.262 715.567 349.949 708.196 348.4C697.351 346.121 686.901 375.018 686.902 401.022C688.13 428.868 684.854 458.21 697.485 460.864C708.33 463.143 717.864 434.234 722.044 405.595Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M686.901 401.022C688.13 428.868 684.854 458.209 697.485 460.864C698.298 461.035 699.103 461.03 699.9 460.864M699.9 460.864C709.729 458.81 718.176 432.087 722.044 405.595C723.412 396.22 723.643 387.979 723.106 380.884M699.9 460.864C699.9 459.481 699.416 457.5 699.9 453.438M693.484 458.702C693.273 457.096 693.327 454.182 693.484 452.783",
    stroke: "#E5A05C",
    strokeWidth: "2.04752",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M804.039 444.449C810.005 440.464 814.918 435.016 817.464 428.627C824.245 411.609 817.139 392.791 801.591 386.596C786.044 380.401 767.943 389.174 761.162 406.192C757.763 414.724 756.478 424.101 758.001 432.113C738.142 437.833 728.554 443.566 730.506 452.988C732.504 462.631 756.661 461.475 781.609 455.75C783.276 455.367 785.015 454.637 786.747 453.91C788.264 453.274 789.776 452.64 791.228 452.243C792.878 451.283 794.362 450.559 795.727 449.892C797.586 448.985 799.223 448.186 800.756 447.048C801.96 446.155 803.05 445.289 804.039 444.449Z",
    fill: "#F9B466"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M801.591 386.596C786.044 380.401 767.943 389.174 761.162 406.192C757.763 414.724 756.478 424.101 758.001 432.113C738.142 437.833 728.554 443.566 730.506 452.988C732.755 463.839 782.799 460.025 805.327 444.607",
    stroke: "#E5A05C",
    strokeWidth: "2.04752",
    strokeLinecap: "round"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask2",
    maskType: "alpha",
    maskUnits: "userSpaceOnUse",
    x: "253",
    y: "458",
    width: "494",
    height: "177"
  }, /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "500",
    cy: "546.553",
    rx: "247",
    ry: "88",
    fill: "#3F3D56"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "500",
    cy: "546.553",
    rx: "247",
    ry: "88",
    fill: "#141429"
  }), /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "580.804",
    cy: "617.357",
    r: "27.804",
    fill: "#5258CD"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "580.804",
    cy: "621.023",
    r: "24.9796",
    fill: "#5258CD"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M380.067 485.103C394.85 472.731 396.776 450.652 384.342 435.833C371.909 421.015 349.865 419.027 335.082 431.4C320.299 443.772 318.372 465.851 330.806 480.67C343.24 495.488 365.304 497.488 380.067 485.103Z",
    fill: "#FF8400"
  }), /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M380.668 486.27C397.003 472.599 399.131 448.203 385.393 431.829C371.654 415.456 347.297 413.259 330.963 426.93C314.628 440.601 312.5 464.997 326.238 481.371C339.977 497.744 364.356 499.953 380.668 486.27Z",
    fill: "#FF8400"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M365.772 453.305C364.985 452.878 364.095 452.772 363.23 452.952C362.686 453.046 362.127 453.213 361.627 453.468C361.786 453.098 361.905 452.704 361.95 452.295C362.017 451.709 361.959 451.104 361.739 450.542C361.499 449.969 361.16 449.474 360.765 449.028C360.126 448.251 359.264 447.672 358.322 447.373C357.365 447.147 356.38 447.204 355.453 447.538C354.549 447.832 353.709 448.299 352.956 448.897L350.347 445.787L349.493 448.584L351.088 450.483L349.599 451.744L347.926 449.745L345.059 450.237L347.667 453.348L343.569 456.773L346.849 458.014C347.107 457.755 347.435 457.564 347.76 457.425C347.953 457.373 348.131 457.394 348.306 457.468C348.621 457.677 348.879 457.935 349.103 458.254L356.171 466.685C356.43 466.943 356.653 467.263 356.78 467.608C356.811 467.789 356.898 467.921 356.792 468.104C356.707 468.3 356.687 468.288 356.297 468.634L356.601 472.344L360.667 468.928L363.276 472.038L365.208 470.435L362.599 467.324L364.109 466.075L366.717 469.185L368.605 467.611L365.988 464.469C366.923 463.649 367.719 462.695 368.363 461.626C368.94 460.627 369.22 459.483 369.172 458.341C369.019 457.192 368.545 456.13 367.819 455.222C367.253 454.46 366.564 453.817 365.772 453.305ZM351.763 454.353L351.714 454.297L353.024 453.205C353.757 452.595 355.996 450.271 357.803 452.321C359.59 454.359 356.255 457.028 356.255 457.028L354.944 458.12L354.817 457.965L351.763 454.353ZM356.734 460.295L358.243 459.046C358.554 458.79 359.638 457.948 360.025 457.655C360.181 457.527 360.377 457.423 360.549 457.359C360.614 457.342 360.69 457.304 360.754 457.287C361.067 457.169 361.377 457.103 361.684 457.09C361.885 457.07 362.095 457.083 362.282 457.136C362.583 457.228 362.88 457.373 363.154 457.558C363.346 457.696 363.506 457.843 363.654 458.01C363.95 458.344 364.159 458.736 364.218 459.151C364.309 459.747 364.21 460.343 363.936 460.864C363.424 461.846 362.719 462.69 361.875 463.399L360.365 464.648L356.734 460.295Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "604.206",
    cy: "243.427",
    r: "11.7104",
    fill: "#5DD9BD"
  }), /*#__PURE__*/_react.default.createElement("g", {
    filter: "url(#filter4_f)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M604.206 252.965C610.947 252.965 616.412 247.5 616.412 240.759C616.412 234.017 610.947 228.553 604.206 228.553C597.465 228.553 592 234.017 592 240.759C592 247.5 597.465 252.965 604.206 252.965Z",
    fill: "#5DD9BD"
  }))), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter0_f",
    x: "326.691",
    y: "-56.0375",
    width: "645.084",
    height: "645.133",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "100",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter1_f",
    x: "-36.6517",
    y: "17.0314",
    width: "743.057",
    height: "743.126",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "100",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter2_f",
    x: "543",
    y: "579.553",
    width: "75.6079",
    height: "75.6079",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "5",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter3_f",
    x: "302.341",
    y: "403.12",
    width: "106.949",
    height: "106.965",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "7.41811",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/_react.default.createElement("filter", {
    id: "filter4_f",
    x: "585.947",
    y: "222.5",
    width: "36.5175",
    height: "36.5175",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/_react.default.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/_react.default.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/_react.default.createElement("feGaussianBlur", {
    stdDeviation: "3.02636",
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "668.246",
    y1: "501.422",
    x2: "607.736",
    y2: "456.843",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#E7A25D"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.654847",
    stopColor: "#F8B366"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint1_linear",
    x1: "699.688",
    y1: "509.115",
    x2: "769.743",
    y2: "471.975",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    stopColor: "#E7A25D"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.654847",
    stopColor: "#F8B366"
  })), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "1002",
    height: "647",
    fill: "white"
  }))));
};
backgroundImage.defaultProps = {
  width: "1002",
  height: "647",
  viewBox: "0 0 1002 647",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var arrowRight = function arrowRight(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.00016 0.333984L8.06016 1.27398L11.1135 4.33398H0.333496V5.66732H11.1135L8.0535 8.72732L9.00016 9.66732L13.6668 5.00065L9.00016 0.333984Z",
    fill: "currentColor"
  }));
};
arrowRight.defaultProps = {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding-top: 44px;\n  height: 820px;\n  text-align: center;\n  background-color: ", ";\n  ", "\n  ", "\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiary;
}, _utils.mediaQuery.lessThan('lg')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 600px;\n    padding: 0;\n  "]))), _utils.mediaQuery.lessThan('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 500px;\n  "]))), _utils.mediaQuery.lessThan('sm')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    height: 400px;\n  "]))));
var Description = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  z-index: 2;\n"])));
var Title = (0, _styledComponents.default)(_fonts.H1)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 10px;\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.secondary + 'b3';
}, _utils.mediaQuery.lessThan('sm')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 30px;\n  "]))));
var SubTitle = (0, _styledComponents.default)(_fonts.P)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-bottom: 30px;\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.secondary;
});
var Image = (0, _styledComponents.default)(function () {
  return /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
    as: backgroundImage
  });
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 44px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1;\n  ", "\n  ", "\n  ", "\n"])), _utils.mediaQuery.lessThan('xl')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    max-width: 100%;\n  "]))), _utils.mediaQuery.lessThan('lg')(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    top: 0;\n  "]))), _utils.mediaQuery.lessThan('sm')(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    top: 170px;\n    height: auto;\n  "]))));
var HeaderContainer = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding-bottom: 55px;\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.tertiary;
});
var NotFound = function NotFound(_ref5) {
  var Header = _ref5.headerComponent,
    Footer = _ref5.footerComponent,
    onBtnClick = _ref5.onBtnClick;
  var _useTranslation = (0, _useTranslation2.useTranslation)('libLayout'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "min-vh-100 d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement(HeaderContainer, null, /*#__PURE__*/_react.default.createElement(_Container2.Container, null, /*#__PURE__*/_react.default.createElement(Header, null))), /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(Description, null, /*#__PURE__*/_react.default.createElement(Title, null, t('notFound.title')), /*#__PURE__*/_react.default.createElement(SubTitle, null, t('notFound.subtitle')), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    iconPosition: "left",
    icon: /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
      as: arrowRight,
      rotate: 180
    }),
    onClick: onBtnClick
  }, t('notFound.button'))), /*#__PURE__*/_react.default.createElement(Image, null)), /*#__PURE__*/_react.default.createElement(_Container.Container, null, /*#__PURE__*/_react.default.createElement(Footer, null)));
};
exports.NotFound = NotFound;